import React from "react";
import { useTranslation } from "react-i18next";
import { Member } from "../common/ObjectTypes";
import ModalShell from "../common/ModalShell";
import { buttonClasses } from "../common/tailwindClassnames";

type RemoveMemberProps = {
    onToggleModal: Function,
    onRemoveMember: Function,
    memberid: string,
    currentMember: Member,
    superuser: boolean,
    orgName?: string,
}

const RemoveMemberModal = ({
    onToggleModal,
    onRemoveMember,
    memberid,
    currentMember,
    superuser,
    orgName,
}: RemoveMemberProps) => {
    const { t } = useTranslation();

    const canRemove = superuser || currentMember.role === "admin";

    return (
        <ModalShell
            title={t(canRemove ? "Remove User" : "Action Denied")}
            subtitle={canRemove ? orgName : undefined}
            onClose={() => onToggleModal()}
            footer={canRemove ? (
                <>
                    <button
                        className={buttonClasses.destructive}
                        type="button"
                        onClick={() => onRemoveMember(memberid)}
                    >
                        {t("Remove")}
                    </button>
                    <button
                        className={buttonClasses.cancel}
                        type="button"
                        onClick={() => onToggleModal()}
                    >
                        {t("Cancel")}
                    </button>
                </>
            ) : undefined}
        >
            <p className="text-ui-text-primary-text">
                {canRemove
                    ? t("Are you sure you want to remove this user from the workspace?")
                    : t("You do not have permission to remove workspace members. Contact support with any questions.")}
            </p>
        </ModalShell>
    );
};

export default RemoveMemberModal;
